import NumberUtils from "@/utils/NumberUtils";
import dayjs from "dayjs";

export default class FormatUtils {

  static format(baeString: string, ...params: any[]) {
    let i = 0
    for (const param of params) {
      baeString = baeString.replace('{' + i + '}', param)
      i++
    }
    return baeString
  }

  static datetimeFormat(value: Date | null | undefined, formatString: string) {
    if (value === null || value === undefined) {
      return ''
    }
    return dayjs(value as Date).format(formatString) as string
  }

  static numberFormat(value: number | null | undefined, maxDigits?: number, noComma?: boolean): string{
    console.log('value=' + value)
    if(value===null || value===undefined){
      return ''
    }
    return NumberUtils.format(value, maxDigits, noComma)
  }


  static timeTextFormat(value: string|null|undefined){
    if(value===null || value===undefined){
      return ''
    }
    const dj = dayjs('2000-01-01 ' + value)
    if(dj.isValid() && dj.toDate().getTime()){
      return dj.format('HH:mm') as string
    }else{
      return ''
    }
  }

  static minituesToHour(valueStr: string){
    const value = new Number(valueStr) as number
    const minutes = value % 60
    const hours = Math.floor(value / 60)
    if(minutes===0) {
      return hours.toString() + '時間'
    }else{
      return (hours ? hours.toString() + '時間' : '') + minutes.toString() + '分'
    }
  }
}